import React, { useEffect, useState } from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
/** 
 * Required css & jss assett
 */
//import './assets/css/main.css';//css
//import './assets/css/main-central-form.css'
/**
 * Parts
 */
//import Header from './components/parts/Header';
//import Footer from './components/parts/Footer';
/**
 * Main Router
*/
import MainRoutes from './routes/Routes';

function App() {
return (
    <div className={`App cf-app`}>
        <MainRoutes />
    </div>
    );
}

export default App;
